import React from 'react';
import { theme } from 'antd';

const { useToken } = theme;

const CheckIcon = ({ color, ...rest }: { color?: string; className?: string; [x: string]: unknown }) => {
  const { token } = useToken();
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" {...rest}>
      <g transform="translate(1 1)" fill="none" fillRule="evenodd">
        <path stroke={color ?? token.colorBgContainer} strokeLinecap="round" strokeLinejoin="round" d="M4 8l2 2 4-6" />
      </g>
    </svg>
  );
};

export default CheckIcon;
